const requireModule = require.context('./', false, /(?!index)([\w\-\.]+)(\.ts)$/);

requireModule.keys().forEach(requireModule);
